'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('focus')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/focus.js
// module id = 116
// module chunks = 35783957827783 114276838955818 214865505688126